import React from "react";
import "../components/Styles/DocumentPage.css";

function DocumentPage() {
  return (
    <div className="document-page">

      {/* HERO BANNER */}
      <div className="doc-hero-banner">

  <div className="doc-hero-overlay">

    <div className="doc-discount-box">
      <span>SAVE</span>
    </div>

    <h2 className="doc-hero-percent">45%</h2>

    <h1 className="doc-hero-title">
      On Legal documents
    </h1>

  </div>

</div>

      {/* FEATURES SECTION */}

<div className="features-section">

  <div className="container">

    <div className="features-wrapper">

      {/* LEFT CONTENT */}

      <div className="features-left">

        <h2>
          Create legal document Drafted By <br />
          Expert Corporate Lawyers
        </h2>

        <h5>FEATURES</h5>

        <p className="feature-text">
          LegalAxis’s Document drafting service offers the following features:
        </p>

        <div className="feature-list">

          <div className="feature-item active">
            <span>01</span>
            <p>TRANSPARENT PRICING, NO HIDDEN CHARGES</p>
          </div>

          <div className="feature-item">
            <span>02</span>
            <p>
              NO FOLLOW-UPS REQUIRED, REAL-TIME UPDATES ON
              WHATSAPP AND EMAIL
            </p>
          </div>

          <div className="feature-item">
            <span>03</span>
            <p>
              SERVICE DELIVERED THROUGH EXPERIENCED SENIOR
              CORPORATE LAWYERS
            </p>
          </div>

          <div className="feature-item">
            <span>04</span>
            <p>
              NO TRAVEL, NO WAITING, GET DOCUMENTS DRAFTED
              FROM THE COMFORT OF YOUR HOME
            </p>
          </div>

          <div className="feature-item last-item">
            <span>05</span>
            <p>CUSTOMISE DOCUMENT AS PER YOUR REQUIREMENT</p>
          </div>

        </div>

      </div>

      {/* RIGHT IMAGE */}

      <div className="features-right">

        <img
          src="https://img.freepik.com/free-vector/business-contract-concept-illustration_114360-4407.jpg?w=900&t=st=1720000000~exp=1720000600~hmac=dummy"
          alt="Legal Documents"
        />

      </div>

    </div>

  </div>

</div>

{/* Documents Section */}
<section className="documents-section">
  <div className="container">

    <h2 className="documents-title">
      Documents for all your Needs
    </h2>

    {/* Tabs */}
    <div className="documents-tabs">
      <button className="active">Startup Documents</button>
      <button>Agreements & Contracts</button>
      <button>Property Documents</button>
    </div>

    {/* Cards */}
    <div className="documents-grid">

      {/* Card 1 */}
      <div className="document-card">
        <h3>Term Sheet Drafting</h3>

        <div className="price-box">
          <h1>₹ 3499</h1>

          <div className="old-price">
            <span>₹ 8999</span>
            <p>(62% Off)</p>
          </div>
        </div>

        <ul>
          <li>Get your term sheet reviewed by the best startup lawyers</li>
          <li>Understand the key terms of your term sheet</li>
          <li>Negotiate a better term sheet with the help of an expert</li>
          <li>Get the mentorship on your term sheet from the best in industry</li>
          <li>Get the review done in less than 24 Hrs.</li>
        </ul>

        <button>Know More</button>
      </div>

      {/* Card 2 */}
      <div className="document-card">
        <h3>Privacy Policy</h3>

        <div className="price-box">
          <h1>₹ 3999</h1>

          <div className="old-price">
            <span>₹ 6999</span>
            <p>(50% Off)</p>
          </div>
        </div>

        <ul>
          <li>Discuss with expert about your requirements</li>
          <li>Impeccable drafting for your App & Website</li>
          <li>24 Hrs Drafting delivery</li>
          <li>Discuss in your language</li>
        </ul>

        <button>Know More</button>
      </div>

      {/* Card 3 */}
      <div className="document-card">
        <h3>Shareholder Subscription Agreement</h3>

        <div className="price-box">
          <h1>₹ 14999</h1>

          <div className="old-price">
            <span>₹ 28999</span>
            <p>(66% Off)</p>
          </div>
        </div>

        <ul>
          <li>Get impeccable shareholder agreement drafted</li>
          <li>Discussion with India's top Startup expert</li>
          <li>Best document drafting experts in the country</li>
          <li>Delivery in just 5 working days</li>
        </ul>

        <button>Know More</button>
      </div>

      {/* Card 4 */}
      <div className="document-card">
        <h3>Terms of Use</h3>

        <div className="price-box">
          <h1>₹ 4999</h1>

          <div className="old-price">
            <span>₹ 7999</span>
            <p>(65% Off)</p>
          </div>
        </div>

        <ul>
          <li>Get website mandatory documents</li>
          <li>Tailor made Terms of Use drafting</li>
          <li>Quick and reliable drafting</li>
          <li>Professional legal support</li>
        </ul>

        <button>Know More</button>
      </div>

    </div>
  </div>
</section>

{/* Chat Section */}
<section className="document-chat-section">
  <div className="container">

    <div className="document-chat-box">

      <div className="document-chat-left">

        <h2>
          Chat <span>with us</span>
        </h2>

        <p>
          Chat with us for all your documentation need.
        </p>

        <button>Chat Now</button>

      </div>

      <div className="document-chat-right">

        <img
          src="https://images.unsplash.com/photo-1521791136064-7986c2920216?q=80&w=1200&auto=format&fit=crop"
          alt="Chat With Us"
        />

      </div>

    </div>

  </div>
</section>

{/* Why LegalKart Section */}
<section className="document-why-legalkart">
  <div className="container">

    <h2>Why LegalAxis?</h2>

    <div className="document-why-grid">

      {/* Card 1 */}
      <div className="document-why-card">
        <div className="document-icon pink">
          <i className="fa-solid fa-hand-pointer"></i>
        </div>

        <h3>Lawyer on Demand</h3>

        <p>
          Get your Document drafted from an experienced legal professional.
        </p>
      </div>

      {/* Card 2 */}
      <div className="document-why-card">
        <div className="document-icon green">
          <i className="fa-solid fa-headset"></i>
        </div>

        <h3>
          Senior Legal Professionals <br />
          with 24X7 Support
        </h3>

        <p>
          Talk with expert lawyers anytime and get realtime support.
        </p>
      </div>

      {/* Card 3 */}
      <div className="document-why-card">
        <div className="document-icon purple">
          <i className="fa-regular fa-bell"></i>
        </div>

        <h3>
          Realtime Alerts <br />
          & updates
        </h3>

        <p>
          Get instant updates and notifications regarding your documents.
        </p>
      </div>

    </div>
  </div>
</section>

{/* ================= OUR CLIENTS SECTION ================= */}

<section className="document-clients-section">
  <div className="container">

    <h2>Our Clients</h2>

    <div className="document-clients-grid">

      <div className="document-client-box">
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/7/7b/Ola_Cabs_logo.svg"
          alt="Ola"
        />
      </div>

      <div className="document-client-box">
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/0/0b/Shadowfax_logo.png"
          alt="Shadowfax"
        />
      </div>

      <div className="document-client-box">
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/5/5b/Rivigo_Logo.png"
          alt="Rivigo"
        />
      </div>

      <div className="document-client-box">
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/9/90/Zoomcar_Logo.png"
          alt="Zoomcar"
        />
      </div>

      <div className="document-client-box">
        <img
          src="https://dummyimage.com/250x80/f2f2f2/999999&text=Module+Innovations"
          alt="Module Innovations"
        />
      </div>

      <div className="document-client-box">
        <img
          src="https://dummyimage.com/180x100/333/ffffff&text=P"
          alt="Client"
        />
      </div>

      <div className="document-client-box">
        <img
          src="https://dummyimage.com/250x80/ffffff/000000&text=BASIC+HOME+LOANS"
          alt="Basic Home Loans"
        />
      </div>

      <div className="document-client-box">
        <img
          src="https://dummyimage.com/250x80/ffffff/333333&text=SpringRole"
          alt="SpringRole"
        />
      </div>

    </div>

  </div>
</section>

    </div>
  );
}

export default DocumentPage;